// Services page 
// src/pages/Services.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  const [activeTab, setActiveTab] = useState('tab-1');
  const img = (path) => process.env.PUBLIC_URL + path;

  const tabs = [
    {
      id: 'tab-1',
      title: 'Voice Over Service',
      desc: 'Wications provides professional voice-over solutions in multiple regional languages. With a dedicated team of native speakers and trained artists, we ensure your content sounds authentic and connects with the intended audience across media types.',
      list: ['Multilingual Voice-Overs', 'Script Translation and Localization', 'Adaptation for Tone and Style'],
      image: '/assets/images/resource/img1.png'
    },
    {
      id: 'tab-2',
      title: 'Proofreading Service',
      desc: 'Our experienced linguistic reviewers ensure your content is grammatically flawless and culturally appropriate. Wications follows a multi-tiered review process to maintain high-quality standards across all translated materials.',
      list: ['Grammar and Spelling Checks', 'Cultural and Linguistic Accuracy', 'Consistency and Clarity'],
      image: '/assets/images/resource/img2.png'
    },
    {
      id: 'tab-3',
      title: 'Translations Service',
      desc: 'Wications specializes in accurate and culturally adapted translations in Sri Lankan and South Indian languages. From corporate communication to marketing, legal, and technical documents, our expert linguists handle a wide range of industry verticals.',
      list: ['Industry-Specific Expertise', 'Website and Software Localization', 'Multi-language Project Handling'],
      image: '/assets/images/resource/img3.png'
    },
    {
      id: 'tab-4',
      title: 'Subtitle Service',
      desc: 'We provide subtitle creation and translation for films, e-learning videos, advertisements, and digital content. Our subtitling team ensures linguistic accuracy, timing precision, and viewer engagement across regional and international audiences.',
      list: ['Accurate Synchronization', 'Subtitles for OTT, Corporate & Education', 'Multilingual Subtitling'],
      image: '/assets/images/resource/img4.png'
    },
    {
      id: 'tab-5',
      title: 'DTP Service',
      desc: "Wications offers multilingual Desktop Publishing (DTP) services that retain your brand's layout and styling, even in complex scripts and right-to-left languages. We adapt your designs to suit linguistic and cultural preferences without compromising quality.",
      list: ['Multilingual Typesetting', 'File Compatibility & Format Matching', 'Print-Ready Layouts'],
      image: '/assets/images/resource/img5.png'
    },
    {
      id: 'tab-6',
      title: 'Transcription Services',
      desc: 'Wications delivers accurate, industry-compliant transcriptions for audio and video recordings. Whether you need verbatim transcripts, edited summaries, or time-stamped formats, we tailor our services to meet diverse business needs.',
      list: ['Audio and Video Transcription', 'Legal, Medical & Business Transcripts', 'Time-Coded Output Formats'],
      image: '/assets/images/resource/img6.png'
    },
  ];

  return (
    <div className="boxed_wrapper ltr">
      {/* Banner Section */}
      <section className="page-title centred pt_130 pb_150" style={{ backgroundImage: "url('/assets/images/banner/translation.jpg')", backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 1 }}></div>
        <div className="auto-container" style={{ position: 'relative', zIndex: 3 }}>
          <div className="content-box">
            <span className="sub-title-three" style={{ color: '#fff' }}>Services</span>
            <h1 style={{ color: '#fff' }}>Exclusive Services</h1>
          </div>
        </div>
      </section>

      {/* Service Tabs Section */}
      <section className="service-style-three pt-5 pb_150">
        <div className="pattern-layer">
          <div className="pattern-1" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-68.png')})` }}></div>
          <div className="pattern-2" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-69.png')})` }}></div>
        </div>
        <div className="auto-container">
          <div className="sec-title mb_55 centred" data-animation-box>
            <span className="sub-title overlay-anim-white-bg" data-animation="overlay-animation">Offer Included</span>
            <h2>Service Included</h2>
          </div>
          <div className="tabs-box">
            <div className="tab-btn-box p_relative mb_60">
              <ul className="tab-btns tab-buttons clearfix">
                {tabs.map(tab => (
                  <li key={tab.id} className={`tab-btn ${activeTab === tab.id ? 'active-btn' : ''}`} onClick={() => setActiveTab(tab.id)}>{tab.title.split(' ')[0]}</li>
                ))}
              </ul>
            </div>
            <div className="tabs-content">
              {tabs.map(tab => (
                <div key={tab.id} className={`tab ${activeTab === tab.id ? 'active-tab' : ''}`} id={tab.id}>
                  <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                      <div className="content_block_three">
                        <div className="content-box mr_40">
                          <h2>{tab.title}</h2>
                          <p>{tab.desc}</p>
                          <ul className="list-style-two clearfix">
                            {tab.list.map((point, idx) => (
                              <li key={idx}>{point}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                      <div className="image-box ml_40">
                        <figure className="image"><img src={img(tab.image)} alt={tab.title} /></figure>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="cta-style-two centred">
  <div className="auto-container">
    <div className="inner-container">
      <div
        className="pattern-layer"
        style={{ backgroundImage: "url(/assets/images/shape/shape-51.png)" }}
      ></div>

      <div className="thumb-box">
        <div className="thumb thumb-1">
          <img src="/assets/images/resource/thumb-1.jpg" alt="Thumb 1" />
        </div>
        <div className="thumb thumb-2">
          <img src="/assets/images/resource/thumb-2.jpg" alt="Thumb 2" />
        </div>
        <div className="thumb thumb-3">
          <img src="/assets/images/resource/thumb-3.jpg" alt="Thumb 3" />
        </div>
        <div className="thumb thumb-4">
          <img src="/assets/images/resource/thumb-4.jpg" alt="Thumb 4" />
        </div>
        <div className="thumb thumb-5">
          <img src="/assets/images/resource/thumb-5.jpg" alt="Thumb 5" />
        </div>
      </div>

      <div className="sec-title light mb_25">
        <span className="sub-title-three">Get Translation</span>
        <h2>
          Transform Your<span> Message</span> Today
        </h2>
      </div>

      <p>
        We specialize in providing high-quality translations that preserve the <br />
        tone, intent, and cultural relevance of your original content.
      </p>

      <div className="btn-box">
        <a href="/contact" className="theme-btn btn-one mr_20">
          Schedule a Project
        </a>
        <a href="/about" className="theme-btn btn-two">
          Know More
        </a>
      </div>
    </div>
  </div>
</section>

  {/* FAQ Section */}
  <section className="faq-style-three pb_140">
        <div className="pattern-layer" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-44.png')})` }}></div>
        <div className="auto-container">
          <div className="sec-title mb_55 centred">
            <span className="sub-title overlay-anim-white-bg">General Faq’s</span>
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="row clearfix">
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div className="inner-box mr_30">
                <ul className="accordion-box">
                  {[
                    {
                      q: 'What translation services does Wications offer?',
                      a: 'We offer translation, transcription, subtitling, voice-over, and localization in Sinhala, Tamil, Telugu, Malayalam, and Kannada.'
                    },
                    {
                      q: 'Do you handle industry-specific content?',
                      a: 'Yes. Our linguists specialize in legal, medical, technical, and educational domains.'
                    },
                    {
                      q: 'How long does it take to complete a project?',
                      a: 'It depends on project size. Most documents are completed in 1–3 business days.'
                    },
                    {
                      q: 'Which languages do you specialize in?',
                      a: 'Sinhala, Tamil, Malayalam, Telugu, and Kannada — with multilingual support.'
                    },
                    {
                      q: 'Is my data and content kept confidential?',
                      a: 'Absolutely. We follow strict protocols and sign NDAs when requested.'
                    }
                  ].map((item, idx) => (
                    <li key={idx} className={`accordion block ${idx === 0 ? 'active-block' : ''}`}>
                      <div className={`acc-btn ${idx === 0 ? 'active' : ''}`}>
                        <div className="icon-box"></div>
                        <h4>{item.q}</h4>
                      </div>
                      <div className={`acc-content ${idx === 0 ? 'current' : ''}`}>
                        <div className="text"><p>{item.a}</p></div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 image-column">
              <div className="image-box ml_30">
                <figure className="image"><img src={img('/assets/images/resource/faq-1.jpg')} alt="FAQ" /></figure>
              </div>
            </div>
          </div>
        </div>
      </section>

           {/* CTA Section */}
           <section className="cta-section">
        <div className="bg-color"></div>
        <div className="auto-container">
          <div className="inner-container">
            <div className="pattern-layer">
              {[23, 24, 25, 26].map(n => (
                <div key={n} className={`pattern-${n - 22} ${n !== 23 ? 'rotate-me' : ''}`} style={{ backgroundImage: `url(${img('/assets/images/shape/shape-' + n + '.png')})` }}></div>
              ))}
            </div>
            <div className="inner-box">
              <h2>Let’s Bridge the Language Gap – <br />Get Started Now</h2>
            <div className="btn-box pt-3">
                            <Link to="/contact" className="theme-btn btn-one">Get Started</Link>
                          </div>
            </div>
          </div>
        </div>
      </section>

      
    </div>
  );
};

export default Services;